import { Link as RouterLink, Outlet } from 'react-router-dom';
import { AppBar, Box, Button, Container, Link, Toolbar, Typography } from '@mui/material';

import {
  layoutFooterLinkSx,
  layoutFooterSx,
  layoutLogoLinkSx,
  layoutMainContainerSx,
  layoutNavBoxSx,
  layoutNavButtonSx,
  layoutRootSx,
  layoutToolbarSx,
} from './Layout.styles';

function Layout() {
  return (
    <Box sx={layoutRootSx}>
      {/* AppBar Header */}
      <AppBar position="static" color="default" elevation={1} component="header">
        <Container maxWidth="lg">
          <Toolbar disableGutters sx={layoutToolbarSx}>
            {/* Logo/Home Link */}
            <Link component={RouterLink} to="/" underline="none" sx={layoutLogoLinkSx}>
              🔮 Tarot Fortune Teller
            </Link>

            {/* Navigation Links */}
            <Box sx={layoutNavBoxSx}>
              <Button
                color="inherit"
                component={RouterLink}
                to="/"
                aria-label="Go to home page"
                sx={layoutNavButtonSx}
              >
                Home
              </Button>
              <Button
                color="inherit"
                component={RouterLink}
                to="/reading"
                aria-label="Start a new reading"
                sx={layoutNavButtonSx}
              >
                Reading
              </Button>
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      {/* Main Content */}
      <Container component="main" maxWidth="lg" sx={layoutMainContainerSx}>
        <Outlet />
      </Container>

      {/* Footer */}
      <Box component="footer" role="contentinfo" sx={layoutFooterSx}>
        <Container maxWidth="lg">
          <Typography variant="body2">
            The cards have spoken. •{' '}
            <Link
              href="https://en.wikipedia.org/wiki/Tarot_card_reading"
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={layoutFooterLinkSx}
            >
              Learn more about tarot
            </Link>
          </Typography>
        </Container>
      </Box>
    </Box>
  );
}

export default Layout;
